import {
    Box,
    Button,
    Dialog,
    DialogProps,
    Grid,
    TextField,
} from "@material-ui/core";
import {
    IncidentReviewRequest,
    StatusIncidentReviewRequestDescription,
} from "api";
import React from "react";
import { Title } from "ui/componentes";

interface IncidentReviewRequestInfoDialogProps {
    incidentReviewRequest?: IncidentReviewRequest;
}

const IncidentReviewRequestInfoDialog: React.FC<
    IncidentReviewRequestInfoDialogProps & DialogProps
> = ({ incidentReviewRequest, ...props }) => {
    return (
        <Dialog open={props.open} maxWidth="md" onClose={props.onClose}>
            <Box p={3}>
                <Grid container spacing={1}>
                    <Grid item xs={12}>
                        <Title text="Solicitação para revisão de penalidade" />
                    </Grid>
                    <Grid item xs={12}>
                        <TextField
                            disabled
                            id="description"
                            name="description"
                            label="Descrição"
                            value={incidentReviewRequest?.description}
                            multiline
                            rows={4}
                        />
                    </Grid>
                    <Grid item xs={12}>
                        <TextField
                            disabled
                            id="answerDescription"
                            name="answerDescription"
                            label="Resposta"
                            value={incidentReviewRequest?.answerDescription}
                            multiline
                            rows={4}
                        />
                    </Grid>
                    <Grid item xs={12}>
                        <TextField
                            disabled
                            id="status"
                            name="status"
                            label="Status"
                            value={
                                StatusIncidentReviewRequestDescription[
                                    incidentReviewRequest?.status || ""
                                ]
                            }
                        />
                    </Grid>
                    <Grid item xs={12}>
                        <Box display="flex" flexDirection="row-reverse">
                            <Button
                                fullWidth={false}
                                onClick={() => {
                                    if (props.onClose) {
                                        props.onClose({}, "escapeKeyDown");
                                    }
                                }}
                            >
                                Fechar
                            </Button>
                        </Box>
                    </Grid>
                </Grid>
            </Box>
        </Dialog>
    );
};

export { IncidentReviewRequestInfoDialog };
